import { Module } from '@nestjs/common';
import { winstonConfig } from '../common/logger/winston.config';
import { CategoriasController } from './categorias.controller';
import { CategoriasService } from './categorias.service';

@Module({
  imports: [],
  controllers: [CategoriasController],
  providers: [CategoriasService],
})
export class CategoriasModule {}
